import { useQueryClient } from '@tanstack/react-query';

import { getApiV1SerieQueryOptions, useDeleteApiV1SerieId } from '@/shared/api/generated';

/**
 * Hook para excluir uma Série.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/serie/{id}` e
 * invalida o cache da listagem após a exclusão bem-sucedida. Exclusão física —
 * remove também idiomas, turmas vinculadas, vídeos e idiomas dos vídeos.
 *
 * @example
 * ```tsx
 * const deleteSerie = useDeleteSerie();
 * deleteSerie.mutate({ id: 105 });
 * ```
 */
export function useDeleteSerie() {
  const queryClient = useQueryClient();

  return useDeleteApiV1SerieId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1SerieQueryOptions());
      },
    },
  });
}
